<template>

<v-dialog v-model="dialog" width="700px">
  <v-card>
    <p class=".title ma-2">Overrule the Google address of {{huis.huis_code}} </p>
    <span class="ma-2">Current google address : {{huis.huis_google_adres}} </span><br>
    <v-form ref="overruleAddress" v-model="overruleAddressValid">
    
    <v-row no-gutters>
                    <v-col cols="10" class="px-1">
                      <v-text-field v-model="huis.huis_straat" label="Street" :rules="huis_straatRule"></v-text-field>
                    </v-col>
                      <v-col cols="2" class="px-1">
                      <v-text-field v-model="huis.huis_huisnummer" label="Number" :rules="huis_huisnummerRule"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="5" class="px-1">
                      <v-text-field v-model="huis.huis_postcode" label="Postal code" :rules="huis_postcodeRule"></v-text-field>
                    </v-col>
                    <v-col cols="7" class="px-1">
                      <v-text-field v-model="huis.huis_plaats" label="City" :rules="huis_plaatsRule"></v-text-field>
                    </v-col>
    </v-row>

    </v-form>
    <v-card-actions class="card-actions">
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="saveAddress" :disabled="!overruleAddressValid">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>

export default {
  data() { 
    return {
      dialog: false,
      overruleAddressValid: false,
      huis_encrid: null,
      huis: {},
      huis_straatRule: [
          v => (v && v.length >= 3) || "A Street is required"
      ],
      huis_huisnummerRule: [
          v => (v && v.length >= 1) || "A number is required"
      ],  
      huis_postcodeRule: [
          v => (v && v.length >= 3) || "A postcalCode is required"
      ],
      huis_plaatsRule: [
          v => (v && v.length >= 3) || "A City is required"
      ]    
    }
  },
  methods: {
    open(huis_encrid) {
      this.$axios
        .post("ares/json/ares/huis/getHuisToOverruleAddress.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuisToOverruleAddress"
          },
          getHuisToOverruleAddress: {
            huis_encrid: huis_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.huis = res.data.getHuisToOverruleAddress;
            this.dialog = true;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    saveAddress() { 
      this.$axios
        .post("ares/json/ares/huis/saveHuisGpac.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveHuisGpac"
          },
          saveHuisGpac: {
            huis_encrid: this.huis.huis_encrid,
            huis_straat: this.huis.huis_straat,
            huis_huisnummer: this.huis.huis_huisnummer,
            huis_postcode: this.huis.huis_postcode,
            huis_plaats: this.huis.huis_plaats
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             this.$router.reload('/huis/onHuis/' + res.data.saveHuisGpac.huis_encrid);            
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.saveHuisGpac.text,
              color: res.data.saveHuisGpac.color
            }); 
            this.dialog = false;
          }
        })
    }
  }
}
</script>
